import { conversationFromBack, conversationToBack } from '@entities/Conversation/responseFormatters';
import { ConversationFront, ConversationBack } from '@entities/Conversation/types';
import { messageFromBack } from '@entities/Message/responseFormatters';
import type { MessageBack, MessageFront } from '@entities/Message/types';
import { convertFiltersToApiParams } from '@features/ui-filters/api/filterUtils';
import { PaginatedOptions, PaginatedResponse } from '@root/src/types/common';
import { mapPaginatedResponse } from '@root/src/utils/formatters/responseAdapters';
import { fetchRequest, RequestMethod } from '@services/api/utils/utils';

const getConversations = async ({
  filters = {},
  page = 1,
  pageSize = 15,
  sort = { field: 'updatedAt', order: 'DESC' },
}: PaginatedOptions = {}): Promise<PaginatedResponse<ConversationFront>> =>
  fetchRequest<PaginatedResponse<ConversationBack>, PaginatedResponse<ConversationFront>>({
    endpoint: '/conversations',
    method: RequestMethod.GET,
    query: convertFiltersToApiParams(filters, {
      page,
      pageSize,
      sorted: [
        {
          id: sort.field,
          desc: sort.order,
        },
      ],
    }),
    responseFormatter: data => mapPaginatedResponse(data, conversationFromBack),
  });

const getConversation = async (
  conversationId: string,
  { from }: { from?: string } = {},
): Promise<ConversationFront & { messages: MessageFront[] }> =>
  fetchRequest<ConversationBack & { messages: MessageBack[] }, ConversationFront & { messages: MessageFront[] }>({
    endpoint: `/conversations/${conversationId}`,
    method: RequestMethod.GET,
    query: { from },
    responseFormatter: data => ({
      ...conversationFromBack(data),
      messages: data.messages.map(messageFromBack),
    }),
  });

const updateConversation = async (conversation: ConversationFront): Promise<ConversationFront> =>
  fetchRequest<ConversationBack, ConversationFront, ConversationBack>({
    endpoint: `/conversations/${conversation.id}`,
    method: RequestMethod.PUT,
    body: conversationToBack(conversation),
    responseFormatter: conversationFromBack,
  });

const markConversationRead = async (conversationId: string, to?: Date): Promise<ConversationFront> =>
  fetchRequest<ConversationBack, ConversationFront>({
    endpoint: `/conversations/${conversationId}/read`,
    method: RequestMethod.PUT,
    query: to ? { to: to.getTime() } : undefined,
    responseFormatter: conversationFromBack,
  });

/*
const createConversationMessage = async (conversationId: string, content: string): Promise<MessageFront> =>
  fetchRequest<MessageBack, MessageFront, { content: string }>({
    endpoint: `/conversations/${conversationId}/messages`,
    method: RequestMethod.POST,
    body: { content },
    responseFormatter: messageFromBack,
  });

const deleteConversation = async (conversationId: string): Promise<void> =>
  fetchRequest<void, void>({
    endpoint: `/conversations/${conversationId}`,
    method: RequestMethod.DELETE,
  });
*/

export const conversationApi = {
  getConversations,
  getConversation,
  updateConversation,
  // createConversationMessage,
  markConversationRead,
  // deleteConversation,
};
